<template>
  <div
    :class="
      clsx('bg-surface flex flex-col lg:rounded-lg gap-4', {
        'p-4 -mx-4 lg:mx-0 lg:px-0': isB2C,
        'p-4': !isB2C,
      })
    ">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { isB2C } from "@/brandconfig";
import clsx from "clsx";
</script>
